import { notificationAPI } from '@/lib/api';
import usePolledCount from '@/hooks/usePolledCount';

export const NOTIFICATIONS_READ_EVENT = 'farm-africa:notifications-read';

const EVENTS = [NOTIFICATIONS_READ_EVENT];
const fetchUnread = async () => (await notificationAPI.unreadCount())?.data?.unread;

/** Unread notifications for the header bell badge. */
export default function useNotificationUnread() {
  return usePolledCount(fetchUnread, EVENTS);
}
